import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Text from "@/components/common/Text"

const COLOR_VARIANTS = Object.seal({
	DARK: "dark",
	LIGHT: "light",
})

const SIZE_VARIANTS = Object.seal({
	WIDE: "wide",
	SLIM: "slim",
})

function getTileData(data) {
	return {
		header: data?.header || "",
		description: data?.description || "",
		colorVariant: data?.colorVariant || COLOR_VARIANTS.DARK,
		sizeVariant: data?.sizeVariant || SIZE_VARIANTS.SLIM,
	}
}

const Wrapper = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(24)};
	}
`

const Header = styled.div`
	display: flex;
	align-items: center;
	background: ${({ theme }) => theme.colors.richBlue};
	color: ${({ theme }) => theme.colors.whiteSmoke};
	min-height: ${getCssSizeValue(86)};
	padding: ${getCssSizeValue(8, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(19, BREAKPOINTS.TABLET)} ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(19)} ${getCssSizeValue(32)};
	}

	&.light {
		background: ${({ theme }) => theme.colors.periwinkle};
		color: ${({ theme }) => theme.colors.richBlack};
	}
`

const Description = styled(Text)`
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(24, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(19, BREAKPOINTS.TABLET)} ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(19)} ${getCssSizeValue(32)};
	}
`

export default function Tile({ item }) {
	const { header, description, colorVariant, sizeVariant } = getTileData(item)
	const wrapperSizeClassName =
		sizeVariant === SIZE_VARIANTS.SLIM ? "col-desktop-4 col-tablet-4 col-mobile-8" : "col-desktop-8 col-tablet-8 col-mobile-8"
	const headerWrapperSizeClassName =
		sizeVariant === SIZE_VARIANTS.SLIM ? "col-desktop-16 col-tablet-8 col-mobile-8" : "col-desktop-8 col-tablet-8 col-mobile-8"
	const headerBg = colorVariant === COLOR_VARIANTS.LIGHT ? "light" : ""

	return (
		<Wrapper className={wrapperSizeClassName}>
			<GridContainer className="no-margin">
				<Header className={`${headerWrapperSizeClassName} ${headerBg} typo-borna typo-borna-104`}>{header}</Header>
			</GridContainer>
			<Description dangerouslySetInnerHTML={getHtmlFromRedactorField(description)} className="typo-strawford typo-strawford-105" />
		</Wrapper>
	)
}
